import cloneDeep from 'lodash.clonedeep'
import moment from 'moment'
import isNil from 'lodash.isnil'
import { Message } from 'element-ui'
import { LangName } from '~/config/cookieKeys'
import {
  default_country,
  default_currency,
  default_good_lang,
  default_site_lang,
  GET_SITE_ID,
  isBuildWebSite,
  PAY_URL
} from '~/config'
import { NativePages, PageNameEnum, ProtocolUrls, CustomNativePages } from "~/enums/pageEnum"
import { NavTypeEnum, WidgetModelNames } from '~/enums/siteEnum'
import { scrollTo } from "~/utils/dom"
import { getDeviceOs, isMobile } from "~/utils/types"
import { generateDefaultBackground } from "~/site/model/helper"
import { TypeData } from "~/enums/data"


const getType = obj => Object.prototype.toString.call(obj)

const isNumber = t => Object.prototype.toString.call(t).includes('Number')

const createId = (list = [], key = '') => {
  if (!list.length || key === '') return ''
  function compare(key) {
    return function (a, b) {
      const v1 = a[key]
      const v2 = b[key]
      return v1 - v2
    }
  }
  const result = list.sort(compare(key))
  return result[result.length - 1][key] + 1
}


const getQueryString = (name, url) => {
  const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
  const r = url || window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2]); return null
}

//  获取商城语言环境
const getLang = (ctx) => {
  const that = ctx || ctx.app;
  const lang = that.$cookies.get(LangName) || 'en'
  if (lang === 'zh') {
    return 'cn'
  } else {
    return lang
  }
}

export const formatSpePrice = (price) => {
  return Number(price).toString().includes('.') ? Number(price).toFixed(2) : Number(price).toString()
}

//  从path中获取商城语言环境
const getLangFromPath = (path) => {
  let lang = 'en'
  const pathSplit = path.split('/')
  let langIndex = 0;
  if (path.includes('preview')) { // 预览环境
    langIndex = 3
  } else { // 线上环境
    langIndex = 1
  }

  lang = pathSplit[langIndex] || 'en'

  return lang === 'zh' ? 'cn' : lang
}

//   通过ip获取货币环境
const getLangByip = (ctx) => {
  const that = ctx || ctx.app
  const lang = that.$store.state.user.ipInfo
  return lang
}

const transformLangToServer = (langStr) => {
  if (langStr === 'zh') {
    return 'cn'
  }
  return langStr
}

// 获取商店语言环境
// 设计时：固定为en
// 运行时：优先取路由参数，路由参数没有建站器的default_language; 如果改商品多语言设置了该语言环境，则显示该语言环境语言，否则显示en环境语言
const getStoreLang = (that) => {
  if (that.editing) {
    return default_site_lang
  }
  const projectInfo = that.$store.state.project?.info?.project
  // eslint-disable-next-line
  const { default_language, languages } = projectInfo
  const lang = getNeedParamsFormRouteParams(that.$route.params)?.lang || default_language

  // 网站语言包括在商品语言中，商品跟随网站路由中的lang语言；反之商品显示商品默认语言
  if (languages && languages.includes(lang)) {
    return lang
  } else {
    return default_site_lang
  }
}

// 动态加载js fix: 解决head()方法中异步加载完成无通知问题
export const loadJsAsync = (src, async, options) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script")
    script.src = src
    script.async = async
    if (options) {
      for (const key in options) {
        script.setAttribute(key, options[key])
      }
    }

    const onload = () => {
      /// console.info("js loaded: ", src);
      script.removeEventListener("load", onload)
      resolve()
    };

    script.addEventListener("load", onload);
    script.addEventListener("error", (err) => {
      script.removeEventListener("load", onload)
      // eslint-disable-next-line no-console
      console.error("loading js error: ", src, err)
      reject(new Error(`Failed to load ${src}`))
    });

    (document.getElementsByTagName("head")[0] || document.documentElement).appendChild(script)
  });
}
const formatDate = (timestamp, format) => {
  // todo 根据传日格式返回
  // timestamp 精确度为毫秒
  const date = new Date(timestamp);
  const obj = {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate(),
    hour: date.getHours(),
    Minute: date.getMinutes(),
    seconds: date.getSeconds()
  }
  if (!format) {
    return `${obj.year}-${obj.month}-${obj.day} ${obj.hour <= 9 ? '0' + obj.hour : obj.hour}:${obj.Minute <= 9 ? '0' + obj.Minute : obj.Minute}:${obj.seconds <= 9 ? '0' + obj.seconds : obj.seconds}`
  }
}

// 获取localStorage X-Forwarded-For值
const getxfip = (localStorage) => {
  let forwarded = {}
  if (!localStorage) {
    console.error('请传入localStorage')
    return forwarded;
  }
  const ip = localStorage.getItem('X-Forwarded-For') || ''
  if (ip) {
    forwarded = { 'X-Forwarded-For': ip }
  }
  return forwarded
}

// 不能含小数点的货币，country_currency[]，使用向上取整
const ZERO_DECIMAL_CURRENCIES = [
  'BIF', 'CLP', 'DJF', 'GNF', 'JPY', 'KMF', 'KRW', 'MGA', 'IDR',
  'PYG', 'RWF', 'UGX', 'VND', 'VUV', 'XAF', 'XOF', 'XPF',
  'HKD', 'TWD'
]

/**
 * 全建站器统一获取价格方法
 * 优先取ip对应货币价格，没有取usd, 再没有显示没有价格，暂时不支持显示0元
 *
 * @param {*} pricesSetting
 * @param {*} ipInfo
 * @param {*} that
 * @param {*} type - defaultPrice | originalPrice
 * @returns
 */

const getPriceInfo = (pricesSetting = {}, ipInfo = {
  currency: 'USD', country: 'US'
}, that = null, type = 'defaultPrice') => {
  if (!pricesSetting) return { currency: '', currencyLabel: '', price: '', riceTxt: '' }
  const valKey = type === 'defaultPrice'
    ? 'default_value'
    : 'original_value'
  const { currency, country } = ipInfo
  const currencyMap = that.$store.state.project.currencieMap
  let info = {
    currency: 'USD',
    currencyLabel: '$',
    price: null,
    priceTxt: that.$i18n.t('siteBuild.store.noPrice')
  }
  if (!Object.keys(pricesSetting).length) {
    // eslint-disable-next-line no-console
    console.warn('请传入价格对象：prices')
    return info
  }
  if (!currency) {
    // eslint-disable-next-line no-console
    console.warn('请传入默认货币：currency')
    return info
  }
  if (!that) {
    // eslint-disable-next-line no-console
    console.warn('请传入this', country)
    return info
  }
  let price = 0
  if (pricesSetting[country] && pricesSetting[country][currency]) {
    price = pricesSetting[country][currency][valKey].toFixed(2)
  }
  const currencyLabel = currencyMap[currency]?.label
  // 不能含小数的货币，向上取整
  const isIntPrice = ZERO_DECIMAL_CURRENCIES.includes(currency)
  if (isIntPrice) {
    price = Math.ceil(price)
  }
  if (price) {
    price = formatSpePrice(price)
    info = {
      currency,
      currencyLabel,
      price,
      labelPrice: `${currencyLabel} ${price}`,
      priceTxt: `${currencyLabel} ${price} ${currency}`
    }
  } else if (pricesSetting[default_country]) {
    let defaultPrice = pricesSetting[default_country] && pricesSetting[default_country][default_currency] ? pricesSetting[default_country][default_currency][valKey] : 0
    // 不能含小数的货币，向上取整
    const isIntPrice = ZERO_DECIMAL_CURRENCIES.includes(default_currency)
    if (isIntPrice) {
      defaultPrice = Math.ceil(defaultPrice)
    } else {
      defaultPrice = defaultPrice.toFixed(2)
    }
    info = {
      currency: default_currency,
      currencyLabel: currencyMap[default_currency]?.label,
      price: defaultPrice,
      labelPrice: `${currencyMap[default_currency]?.label} ${defaultPrice}`,
      priceTxt: defaultPrice ? `${currencyMap[default_currency]?.label} ${defaultPrice} ${default_currency}` : that.$i18n.t('siteBuild.store.noPrice')
    }
  } else {
    info = {
      currency,
      currencyLabel: '$',
      price: 0,
      priceTxt: that.$i18n.t('siteBuild.store.noPrice'),
    }
  }
  return info
}
// 全建站器统一获取商品信息名称，描述信息方法
const getGoodInfo = (names = {}, descs = {}, lang = '', that = null, langIdData = {}) => {
  const info = {
    name: '',
    desc: '',
  }
  // if (!Object.keys(names).length) {
  //   console.error('请传入名称对象： names')
  //   return info;
  // }
  if (!lang) {
    // eslint-disable-next-line no-console
    console.error('请传入语言环境变量：lang')
    return info
  }
  if (!that) {
    // eslint-disable-next-line no-console
    console.error('请传入this')
    return info
  }
  info.name = names.lang_id ? langIdData[names.lang_id] || names.lang_id : names[lang] || names[default_good_lang] || ''
  info.desc = descs.lang_id ? langIdData[descs.lang_id] || descs.lang_id : descs[lang] || descs[default_good_lang] || ''
  return info
}

export function assignObject(origin, target, ignoreKeys = []) {
  const object = cloneDeep(origin)
  for (const key in target) {
    if (!ignoreKeys.includes(key)) {
      object[key] = target[key]
    }
  }
  return object
}

const deppMerge = (target, source) => {
  for (const key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      target[key] =
        target[key] && getType(target).includes('Object')
          ? deppMerge(target[key], source[key])
          : (target[key] = source[key])
    }
  }
  return target;
}

export function sleep(delay = 0) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      resolve()
      clearTimeout(timer)
    }, delay)
  })
}

const mergeToObject = function (target, source) {
  const obj = cloneDeep(target)
  const origin = cloneDeep(source)
  const merge = (t, s) => {
    for (const key in s) {
      if (getType(s[key]).includes('Object')) {
        merge(t[key], source[key])
      } else {
        obj[key] = source[key]
      }
    }
  }
  merge(obj, origin)
  return obj
}

/*
*   判断是否是语言的两位字符
* */
export function isLangParams(lang) {
  return /^[A-Za-z]{2}$/.test(lang)
}

/*
*  取两位字符判断是语言还是页面
* */
export function getLangPageId(lang, pageid, l, p) {
  if (!lang && pageid) {
    if (isLangParams(pageid)) {
      l = pageid
      p = '/'
    } else {
      p = pageid
      l = ''
    }

  } else if (lang && !pageid) {
    if (isLangParams(lang)) {
      l = lang
      p = ''
    } else {
      p = lang
      l = ''
    }
  } else {
    l = lang
    p = pageid
  }

  return [l, p]
}


export function getNeedParamsFormRouteParams(params, isProd) {
  if (isProd === undefined) {
    isProd = process.env.IS_BUILD_SITE
  }
  if (!params) {
    // eslint-disable-next-line
    console.warn('params不能为空')
    return params
  }
  const { lang = '', sid, pageid = '' } = params
  let l = ''
  let n = null
  let s = isProd ? (GET_SITE_ID()) : sid
  const home = '/'
  let p = home
  const arr = getLangPageId(lang, pageid, l, p)
  const isNative = NativePages.includes(lang) || NativePages.includes(pageid)
  const native = NativePages.find(item => item === lang || item === pageid)
  const isCustomNative = CustomNativePages.includes(native)
  if (isNative && !isProd) {
    l = NativePages.find(item => item.includes(arr[1])) ? arr[0] : arr[1]
    p = native === PageNameEnum.VIP_CLUB ? PageNameEnum.VIP_CLUB : home
    n = native
  } else if (!isProd && !sid && !lang && pageid) {
    s = pageid
  } else {
    l = arr[0]
    p = arr[1] || home
  }
  if (isProd && isNative) {
    n = native
    l = isLangParams(arr[1]) ? arr[1] : arr[0]
    p = isCustomNative ? native : home
  }

  return {
    sid: s,
    lang: l || '',
    pageid: p,
    native: n
  }
}

export const getParamsFromUrl = (path, isProd) => {
  const result = {
    headNative: null,
    siteId: null,
    pageId: '',
    langId: null
  }
  if (!isProd) {
    const [headNative, siteId, pageId = '', langId] = path.split('/').filter(item => item)
    result.headNative = headNative
    result.siteId = siteId
    result.pageId = pageId
    result.langId = langId
    const pageIdIsLangId = isLangParams(pageId)
    if (!langId & pageIdIsLangId) {
      result.langId = pageId
      result.pageId = null
    }
  } else {
    const [pageId, langId] = path.split('/').filter(item => item)
    result.siteId = GET_SITE_ID()
    result.pageId = pageId
    result.langId = langId
  }
  const pageIdIsLangId = isLangParams(result.pageId)
  if (pageIdIsLangId && !result.langId) {
    result.langId = result.pageId
    result.pageId = null
  }

  return [result.headNative, result.siteId, result.pageId, result.langId]
}

export const getSiteUrlAnalyzeParams = (collection, isProd) => {
  const path = collection.route.path
  const query = collection.route.query
  const $cookies = collection.app.$cookies
  const redirect = collection.redirect
  const [headNative, siteId, pageId = '', langId] = getParamsFromUrl(path, isProd)
  // console.log(`headNaive:${headNative} siteId:${siteId} pageId:${pageId} langId:${langId}`)
  const result = {
    headNative,
    siteId,
    pageId,
    langId,
    isNative: NativePages.includes(pageId)
  }
  const isPreview = result.headNative === PageNameEnum.PREVIEW
  const lastIdIsLang = isLangParams(pageId) || isLangParams(langId)
  const localLang = $cookies.get('lang')
  if (isPreview) {
    if (!lastIdIsLang && !pageId) {
      localLang && redirect(`/${result.headNative}/${result.siteId}/${localLang}`, query)
    } else if (pageId && !langId) {
      localLang && redirect(`/${result.headNative}/${result.siteId}/${result.pageId}/${localLang}`, query)
    }
  } else if (isProd) {
    if (!lastIdIsLang && !pageId) {
      localLang && redirect(`/${localLang}`, query)
    } else if (!lastIdIsLang && pageId) {
      localLang && redirect(`/${result.pageId}/${localLang}`, query)
    }
  }

  return result
}


export function objectRemoveKey(target, delKey) {
  const result = {}
  if (typeof target !== 'object') {
    return new Error('Must Be Object')
  }
  for (const key in target) {
    if (key !== delKey) {
      result[key] = target[key]
    }
  }
  return result
}

// 获取浏览器语言，转换成系统支持的语言
export function getSysLanguage() {
  let slang = ''
  const sysLang = window.navigator.language ? window.navigator.language.toLocaleLowerCase() : ''
  const langs = ['en', 'cn', 'ar', 'bg', 'pl', 'de', 'ru', 'fr', 'ko', 'cs', 'ro', 'pt', 'ja', 'th', 'tr', 'es', 'he', 'id', 'it', 'vi', 'tw']
  langs.forEach(item => {
    if (sysLang.includes(item)) {
      slang = item
    }
  })
  return slang
}

export function round(num, decimal) {
  if (isNaN(num)) {
    return 0
  }
  const p1 = Math.pow(10, decimal + 1)
  const p2 = Math.pow(10, decimal)
  return Math.round(num * p1 / 10) / p2
}

export const rename = (name, removeFlags) => {
  let result = name
  removeFlags.forEach(item => {
    result = result.replaceAll(item, '')
  })
  return result
}

const setFavicon = (icon) => {
  if (!icon) return
  const removeLink = (target) => {
    document.querySelector(target)?.remove()
  }
  const createLink = (rel) => {
    const $link = document.createElement('link')
    $link.rel = rel
    $link.href = icon
    document.head.appendChild($link)
  }
  removeLink('link[rel="shortcut icon"]')
  removeLink('link[rel="apple-touch-icon"]')
  createLink('shortcut icon')
  createLink('alternate icon')
  createLink('apple-touch-icon')
}

const setPageTitle = (seo, langIdData) => {
  if (!seo) return
  document.title = langIdData[seo?.title] || seo?.title
}

export const getImageSize = (url, cb) => {
  const oImg = new Image()
  if (cb) {
    oImg.addEventListener('load', function () {
      const result = {
        width: this.naturalWidth,
        height: this.naturalHeight,
      }
      typeof cb === 'function' && cb(result)
    })
  }
  const rePro = new Promise((resolve) => {
    oImg.addEventListener('load', function () {
      resolve({
        width: this.naturalWidth,
        height: this.naturalHeight,
      })
    })
  })

  oImg.src = url
  return rePro
}

export const hasOwn = (o, k, type = '', defaultValue = null) => {
  return Object.hasOwn(o || {}, k) ? Object.prototype.toString.call(o[k]).includes(type) ? o[k] : defaultValue : defaultValue
}

export const formatZoneTime = (time, format = 'YYYY-MM-DD HH:mm:ss', isSecond) => {
  const timeStamp = moment.utc(time).local().valueOf()
  return {
    text: !time ? null : moment(timeStamp).format(format),
    value: !time ? null : (isSecond ? timeStamp / 1000 : timeStamp)
  }
}

export const getTextColor = (colorModel, visible) => {
  const isString = typeof colorModel === 'string'
  const color = isString ? colorModel : colorModel?.backgroundColor
  const showColor = typeof visible === 'boolean' ? visible : colorModel?.backgroundColorShow
  return {
    color: showColor ? color : 'unset'
  }
}

export const checkNavDataIsRight = (data) => {
  let result = false
  if (data.navType === NavTypeEnum.URL) {
    result = !!data.url
  } else if (data.navType === NavTypeEnum.PAGE) {
    result = !!data.page
  } else if (data.navType === NavTypeEnum.MODEL) {
    result = !!data.model
  }
  return result
}

export const navTo = async (context, target) => {
  const getEntityParamsUrl = () => {
    let result = target.url
    const isHit = ProtocolUrls.includes(target.url)
    const redirectData = context.$store.state.project.info.redirect
    const isRu = context.$store.state.user.ipInfo?.country === 'RU'
    if (isHit && isRu) {
      result = `${result}?entity=ru`
    } else if (isHit && redirectData) {
      const origin = window.origin.replace('https://', '')
      const domainMap = new Map(Object.entries(redirectData))
      const current = domainMap.get(origin)
      const entity = current === 'airwallex-uk' ? 'uk' : 'hk'
      result = `${result}?entity=${entity}`
    }
    return result
  }

  const toModel = async () => {
    const getWidget = () => {
      let result = null
      const site = cloneDeep(context.site)
      const widgetList = site.widgetList
      for (const key in site) {
        const setting = site[key]
        if (typeof setting === 'object' && setting?.id === target.model) {
          result = setting
          break
        }
      }

      if (result) {
        return result
      }

      for (const key in widgetList) {
        const item = widgetList[key]
        if (item.id === target.model) {
          result = item
          break
        } else if (item?.children) {
          const child = item.children.find(child => child.id === target.model)
          if (child) {
            result = child
            break
          }
        }
      }
      return result
    }
    const widget = getWidget()
    const isDialog = widget?.name === WidgetModelNames.DialogItemWidgetModel
    const isPwa = widget?.name === WidgetModelNames.PwaWidgetModel
    const isCustomerService = widget?.name === WidgetModelNames.SupportSettingWidgetModel
    const isMissionCenter = widget?.name === WidgetModelNames.MissionCenterSettingModel
    if (isDialog) {
      context.$store.commit('site/SET_CURRENT_VISIBLE_DIALOG_ID', widget.id)
    } else if (isPwa) {
      window?.__pwaDownload?.()
    } else if (isCustomerService) {
      await checkUser(context, () => {
        context.$store.commit('site/NEXT_IS_SHOW_CUSTOMER_SERVICE', true)
      })
      window?.AIHelpSupport.show('E004')
    } else if (isMissionCenter) {
      context.$store.commit('site/SET_MISSION_CENTER_VISIBLE', true)
    } else if (!widget?.__hide) {
      scrollTo(target.model, 'site-body', context.$store.getters.isMobile ? 60 : 90)
    }
  }
  if (target.navType === NavTypeEnum.URL) {
    await context.SitePage.to(getEntityParamsUrl())
  } else if (target.navType === NavTypeEnum.PAGE) {
    await context.SitePage.to(target.page)
  } else if (target.navType === NavTypeEnum.MODEL) {
    await toModel()
  }
}

export const isPwa = () => {
  return window.navigator.standalone === true || !!(window.matchMedia('(display-mode: standalone)').matches)
}

export const countdown = (stopTime, context) => {
  let timer
  const runner = () => {
    const now = moment().valueOf()
    const end = formatZoneTime(stopTime * 1000).value
    const leftTime = end - now
    let d = 0; let h = 0; let m = 0; let s = 0
    if (leftTime >= 0) {
      d = Math.floor(leftTime / 1000 / 60 / 60 / 24)
      h = Math.floor(leftTime / 1000 / 60 / 60 % 24)
      m = Math.floor(leftTime / 1000 / 60 % 60)
      s = Math.floor(leftTime / 1000 % 60)
    }
    context.countTime = `${d > 0 ? `${d}d:` : ''}${h < 10 ? `0${h}` : h}:${m < 10 ? `0${m}` : m}:${s < 10 ? `0${s}` : s}`
    if (leftTime > 0) timer = setTimeout(runner, 1000)
  }
  runner()
  return timer
}

export const checkUser = (context, fail) => {
  return new Promise((resolve, reject) => {
    if (context.editing) {
      //
    } else if (isNil(context.$store.state.user.siteUserInfo?.id)) {
      context.$store.commit('user/SET_LOGINSHOW', !context.editing)
      context.$store.commit('user/SET_SITE_BIND_USER', true)
      fail && fail()
    } else {
      resolve()
    }
  })
}

export const generateOrderParams = (context, goods, type) => {
  const $route = window.$nuxt.$route
  const query = $route.fullPath.split('?')[1]
  const return_url = `${window.location.protocol}//${window.location.host}${window.location.pathname}${query ? `?${query}` : ''}`
  const isSandBox = !isBuildWebSite
  const StoreIpInfo = getLangByip(context)
  const { currency } = StoreIpInfo
  const { project_id, merchant_id } = context.$store.state.user.siteUserInfo
  const ipInfo = getxfip(window.localStorage)
  const priceInfo = getPriceInfo(goods.prices_setting, StoreIpInfo, context)
  const price = +priceInfo.price
  const device = isMobile() ? 'mobile' : 'desktop'
  const lang = getParamsFromUrl(context.$route.path, isBuildWebSite)?.[3] || 'en'
  const params = {
    project_id,
    merchant_id,
    currency,
    amount: price,
    from_preview_mode: isSandBox,
    items: [
      {
        item_id: goods.id,
        num: goods.num || 1,
        amount: price,
        price,
        currency,
        virtual_currency: currency,
        virtual_currency_amount: price,
      },
    ],
    settings: {
      view_source: context.$route.query.from,
      device,
      device_type: getDeviceType(),
      language: lang,
      show_order: false,
      return_url,
    },
  }
  if (type === TypeData.recharge) {
    params.recharge_id = goods.rechargeId
    params.denomination_id = goods.id
    params.amount = goods.value
    params.price = goods.value
    delete params.items
    return context.$api.recharge.createRechargeOrder(params, ipInfo)
  } else if (type === TypeData.rollingOffer) {
    params.activity_id = goods.activity_id
    params.items[0].item_id = goods.level_id
    return context.$api.activity.createQuenUnlockOrder(params, ipInfo)  
  } else {
    return context.$api.order.createOrder(params, ipInfo)
  }
}

export const generatePayUrl = (res, context, callback) => {
  const isDev = process.env.NODE_ENV === 'development'
  const isSandBox = !isBuildWebSite
  const sandbox = isSandBox ? 1 : 0
  const device = isMobile() ? 'mobile' : 'desktop'
  const { token, code, monthCardData, pay_url } = res
  let payUrl = ''
  const env = process.env.RUN_ENV
  const isGoPay = token.slice(0, 2) === 'v2'
  if (pay_url && !isDev) {
    payUrl = pay_url
  } else if (isGoPay) {
    payUrl = `${PAY_URL[env]}/new-kop/payelement?access_token=${token}&sandbox=${+sandbox}`
  } else {
    payUrl = `${PAY_URL[env]}/pay/payelement?access_token=${token}&sandbox=${+sandbox}`
  }
  if (device === 'mobile') {
    context.$store.commit('site/SHOW_ORDER_MODAL', { code, payUrl, monthCardData })
  } else {
    context.deskPay = {
      visible: true,
      isGoPay: true,
      payUrl,
      orderCode: code
    }
  }
}

export const getLangIdI18n = (names, langIdData) => {
  const langId = names?.lang_id || names?.langId
  if (langId) {
    return langIdData[langId] || names?.lang_id
  } else {
    return ''
  }
}

export const checkIgnoreMessage = (msg) => {
  return ['数据不存在', 'Data does not exist'].includes(msg)
}

export const getDeviceType = () => {
  const pwa = isPwa()
  return isMobile() ? (pwa ? 'mobile_pwa' : 'mobile') : (pwa ? 'pc_pwa' : 'pc')
}

export const eventTracker = (ctx, type, order_id) => {
  if (!isBuildWebSite) {
    return
  }
  ctx.$api.report.eventTracking({
    project_id: ctx.$store.state.project.info?.project_id,
    store_id: ctx.$store.state.project.info?.id,
    merchant_id: ctx.$store.state.project.info?.merchant_id,
    country: ctx.$store.state.user.ipInfo?.ip_country,
    referer: ctx.$route.query.from,
    device: getDeviceType(),
    order_id,
    type,
    platform: getDeviceOs()
  })
}

export const copyText = (text) => {
  if (!text) {
    return Message.error('拷贝字符为空')
  }
  const type = "text/plain"
  const blob = new Blob([text], { type })
  const data = [new ClipboardItem({ [type]: blob })]
  return new Promise((resolve, reject) => {
    navigator.clipboard.write(data)
      .then(() => {
        resolve('success')
      })
      .catch((e) => {
        Message.error(e)
        reject(e)
      })
  })
}

export const formatGoods = (list, context) => {
  const langIdData = context.$store.state.locale.langIdData
  return list.map(item => {
    const newItem = { ...item }
    newItem.priceInfo = getPriceInfo(newItem.prices_setting, getLangByip(context), context)
    newItem.names = {
      name: getLangIdI18n({ lang_id: item.name }, langIdData),
      desc: getLangIdI18n({ lang_id: item.description }, langIdData)
    }
    newItem.thumbBg = generateDefaultBackground({ backgroundImage: newItem.icon.replace(/\s/g, '%20') })
    newItem.item_contents = (newItem.item_contents || []).map(contentItem => {
      contentItem.name = getLangIdI18n({ lang_id: contentItem.name }, langIdData)
      return contentItem
    })
    return newItem
  })
}

export const getUrlParamsString = (ctx, exclude = []) => {
  const query = ctx.$route.query
  let result = ''
  for (const key in query) {
    if (!exclude.includes(key)) {
      result += `${!result ? '?' : '&'}${key}=${query[key]}`
    }
  }
  return result
}

export const generateWidgetId = (moduleName) => {
  const id = 'site-widget-' + (Date.now() * parseInt(Math.random() * 100))
  return moduleName ? `${id}-${moduleName}` : id
}

export default {
  mergeToObject,
  rename,
  deppMerge,
  isNumber,
  createId,
  getQueryString,
  getLang,
  getStoreLang,
  loadJsAsync,
  formatDate,
  transformLangToServer,
  getLangByip,
  getxfip,
  getPriceInfo,
  getGoodInfo,
  getLangFromPath,
  getNeedParamsFormRouteParams,
  getSysLanguage,
  setFavicon,
  setPageTitle
}
